import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    boletasArresto: [],
  },

  getters: {
    getBoletasArresto: (state) => state.boletasArresto,
  },

  mutations: {
    SET_BOLETAS_ARRESTO(state, boletasArresto) {
      state.boletasArresto = boletasArresto;
    },
  },

  actions: {
    async fetchBoletasArresto({ commit }, idPersonal) {
      await axios
        .get(`PoliciaCuadrantes/C3/personal/${idPersonal}/boletasArresto`)
        .then((response) => {
          commit('SET_BOLETAS_ARRESTO', response.data.data);
        });
    },

    async saveBoletasArresto(_, boletasArresto) {
      await axios
        .post(`PoliciaCuadrantes/C3/personal/${boletasArresto.fk_idPersonal}/boletasArresto`, boletasArresto);
    },

    async updateBoletasArresto(_, boletasArresto) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/personal/${boletasArresto.fk_idPersonal}/boletasArresto/${boletasArresto.fk_idBoletasArresto}`,
          boletasArresto,
        );
    },
  },
};
